import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "progress-ring__label" }
const _hoisted_2 = ["height", "width"]
const _hoisted_3 = ["stroke-dasharray", "stroke-width", "r", "cx", "cy"]

import { computed } from "vue";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressRing',
  props: {
    label: {},
    radius: {},
    progress: {},
    stroke: {}
  },
  setup(__props: any) {

const props = __props;

let normalizedRadius = computed(() => props.radius - props.stroke * 2);
let circumference = computed(() => normalizedRadius.value * 2 * Math.PI);
let strokeDashoffset = computed(() => circumference.value - props.progress / 100 * circumference.value);
let dimension = computed(() => props.radius * 2);
let styles = computed(() => {
  return {
    height: dimension.value - 8 + 'px',
    width: dimension.value - 8 + 'px',
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "progress-ring",
    style: _normalizeStyle(_unref(styles))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1),
    (_openBlock(), _createElementBlock("svg", {
      class: "progress-ring__line",
      height: _unref(dimension),
      width: _unref(dimension)
    }, [
      _createElementVNode("circle", {
        "stroke-dasharray": _unref(circumference) + ' ' + _unref(circumference),
        style: _normalizeStyle({ strokeDashoffset: _unref(strokeDashoffset) }),
        "stroke-width": _ctx.stroke,
        r: _unref(normalizedRadius),
        cx: _ctx.radius,
        cy: _ctx.radius
      }, null, 12, _hoisted_3)
    ], 8, _hoisted_2))
  ], 4))
}
}

})